import { computed } from 'vue';
import { getTenantTaskPriorities, getTenantTaskStatuses } from '~/lib/taskConfig';

export function useTaskOptionCatalog() {
    const tenantStore = useTenantStore();
    const teamStore = useTeamStore();
    const authStore = useAuthStore();
    const userStore = useUserStore();

    const statusOptionDetails = computed(() => getTenantTaskStatuses(tenantStore.currentTenant));
    const statusOptions = computed(() => statusOptionDetails.value.map(option => option.value));
    const priorityOptions = computed(() => getTenantTaskPriorities(tenantStore.currentTenant));

    const assigneeOptions = computed(() => {
        const optionMap = new Map<string, { id: string; label: string; avatarURL?: string }>();

        for (const member of teamStore.members) {
            if (member.status && member.status !== 'active') {
                continue;
            }

            const id = String(member.userId || member.id || '').trim();
            if (!id) continue;

            optionMap.set(id, {
                id,
                label: member.displayName || member.email || 'Unknown user',
                avatarURL: member.avatarURL || undefined,
            });
        }

        const currentUserId = String(authStore.user?.uid || userStore.user?.id || '').trim();
        if (currentUserId) {
            optionMap.set(currentUserId, {
                id: currentUserId,
                label: String(authStore.user?.displayName || userStore.user?.displayName || optionMap.get(currentUserId)?.label || 'You'),
                avatarURL: authStore.user?.photoURL || userStore.user?.avatarURL || optionMap.get(currentUserId)?.avatarURL,
            });
        }

        return Array.from(optionMap.values()).sort((a, b) => a.label.localeCompare(b.label));
    });

    return {
        statusOptions,
        statusOptionDetails,
        priorityOptions,
        assigneeOptions,
    };
}
